module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/x13dhh/tc-custom/9781418566258.jpg?1718043995916",
      "alt": "This image is the cover for the book Renegade, The Lost Book"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Renegade, The Lost Book\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("In "), _c('i', [_vm._v("Renegade, ")]), _vm._v("the third in the Lost Books series, a YA spin-off of the "), _c('i', [_vm._v("New York Times ")]), _vm._v("bestselling Circle series, one of the chosen will leave his world . . . and enter ours.")])]), _c('p', [_c('b', [_vm._v("One of the chosen has gone renegade.")])]), _c('p', [_vm._v("Turning his back on all that he once believed, Billos does the forbidden and enters into a Book of History. He lands in a reality as foreign to him as water is to oil—a place called Paradise, Colorado. He has strange new powers given to him courtesy of a mysterious figure known as Marsuvees Black.")]), _c('p', [_vm._v("The chosen four have survived the desert, escaped the Black Forest, battled the Horde, and added a spirited refugee to their number. But nothing has prepared them for the showdown that Billos, the renegade, is luring them into. ")]), _vm._v("Book 3 of 6 in the Lost Books series (a spin-off of the Circle Series)Lost Books 1: ChosenLost Books 2: InfidelLost Books 3: RenegadeLost Books 4: ChaosLost Books 5: LunaticLost Books 6: ElyonCircle Book 0: GreenCircle Book 1: BlackCircle Book 2: RedCircle Book 3: WhiteFull-length book (70,000 words)\n    "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Ted Dekker\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Thomas Nelson\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0